'use client'
import GoogleMapReact from 'google-map-react'
import Script from 'next/script'
import { useState } from 'react'
import { MenuBall } from '../../common/frame/Ball'

interface MarkerProps {
  lat: number
  lng: number
}

// const Marker: React.FC<MarkerProps> = () => <div style={{ color: 'red' }}>📍</div>
const Marker: React.FC<MarkerProps> = () => <MenuBall className="fill-orange-50" />
const Map = ({
  center,
  defaultProps = {
    zoom: 15,
  },
  value,
}: {
  center: { lat: number; lng: number }
  defaultProps?: { zoom: number }
  value: { lat: number; lng: number }
}) => {
  const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null)
  const [mapsApi, setMapsApi] = useState<typeof google.maps | null>(null)
  const [isMapsApiLoaded, setIsMapsApiLoaded] = useState<boolean>(
    typeof window !== 'undefined' && !!(window as any).google?.maps
  )

  const handleApiLoaded = ({ map, maps }: { map: google.maps.Map; maps: typeof google.maps }) => {
    setMapInstance(map)
    setMapsApi(maps)
  }

  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || ''

  if (!isMapsApiLoaded) {
    return (
      <>
        <Script
          src={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=ko&libraries=places,marker`}
          strategy="afterInteractive"
          onLoad={() => setIsMapsApiLoaded(true)}
        />
      </>
    )
  }

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: apiKey,
        language: 'ko',
      }}
      center={center}
      defaultZoom={defaultProps.zoom}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={handleApiLoaded}
      options={{
        zoomControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        gestureHandling: 'none',
        draggable: false,
        clickableIcons: false,
      }}
    >
      {value && <Marker lat={value.lat} lng={value.lng} />}
    </GoogleMapReact>
  )
}

export default Map
